import { render, staticRenderFns } from "./queryCard.vue?vue&type=template&id=3875e088&scoped=true&"
import script from "./queryCard.vue?vue&type=script&lang=js&"
export * from "./queryCard.vue?vue&type=script&lang=js&"
import style0 from "./queryCard.vue?vue&type=style&index=0&id=3875e088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875e088",
  null
  
)

export default component.exports